import { createRouter, createWebHistory } from 'vue-router'

import { MENU_COLIBRI } from '@/config/menuColibri'
import { instalarGuards } from './guards'

import Login from '@/features/auth/views/LoginView.vue'
const Landing = () => import('@/features/landing/views/LandingView.vue')

// Layout como componente diferido también
const MainLayout = () => import('@/layouts/MainLayout.vue') // ⚠️ AJUSTA LA RUTA

const Dashboard = () => import('@/features/reportes/views/DashboardView.vue')
const Pos = () => import('@/features/ventas/views/PosView.vue')
const Ventas = () => import('@/features/ventas/views/VentasView.vue')
const Despachos = () => import('@/features/ventas/views/DespachosView.vue')

// Inventario: la vista es solo el layout (menú ↔ sección vía <router-view/>)
const Inventario = () => import('@/features/inventario/views/InventarioView.vue')
const InventarioMenu = () => import('@/features/inventario/components/MenuInventario.vue')
const InventarioBodega = () => import('@/features/inventario/components/InventarioBodega.vue')
const InventarioVenta = () => import('@/features/inventario/components/InventarioVenta.vue')
const InventarioMovimientos = () => import('@/features/inventario/components/Movimientos.vue')
const InventarioConteo = () => import('@/features/inventario/components/ConteoStock.vue')

const Lotes = () => import('@/features/lotes/views/LotesView.vue')
const LoteDetalle = () => import('@/features/lotes/views/LotedetalleView.vue')
const Mermas = () => import('@/features/mermas/views/MermasView.vue')
const Compras = () => import('@/features/compras/views/ComprasView.vue')
const Etiquetas = () => import('@/features/lotes/views/EtiquetasView.vue')
const Proveedores = () => import('@/features/compras/views/ProveedoresView.vue')
const Clientes = () => import('@/features/clientes/views/ClientesView.vue')
const Usuarios = () => import('@/features/usuarios/views/UsuariosView.vue')
const Configuracion = () => import('@/features/configuracion/views/ConfiguracionView.vue')
const Reportes = () => import('@/features/reportes/views/ReportesView.vue')
const Promociones = () => import('@/features/promociones/views/PromocionesView.vue')
const Cotizaciones = () => import('@/features/cotizaciones/views/CotizacionesView.vue')

const routes = [
  /* Landing pública: la ven clientes y equipo. Va antes del shell, que
     también cuelga de '/', para que la raíz exacta caiga acá. */
  {
    path: '/',
    name: 'Inicio',
    component: Landing,
    meta: { publica: true, title: 'Floristería' }
  },

  /* ---------------- Fuera del shell (sin sidebar/header) ---------------- */
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { publica: true, title: 'Iniciar sesión' }
  },
  // {
  //   path: '/sin-permiso',
  //   name: 'SinPermiso',
  //   component: Estado,
  //   meta: { title: 'Sin permiso', estado: 'sin-permiso' }
  // },
  // {
  //   path: '/:pathMatch(.*)*',
  //   name: 'NoEncontrado',
  //   component: Estado,
  //   meta: { publica: true, title: 'Página no encontrada', estado: 'no-encontrado' }
  // },

  /* ---------------- Dentro del shell (MainLayout) ---------------- */
  {
    path: '/',
    component: MainLayout,
    children: [
      /* ---------------- Operación ---------------- */
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { permiso: 'dashboard', title: 'Inicio', estado: 'construccion' }
      },
      {
        path: 'reportes',
        name: 'Reportes',
        component: Reportes,
        meta: { permiso: 'reportes', title: 'Reportes' }
      },
      {
        path: 'pos',
        name: 'PuntoDeVenta',
        component: Pos,
        meta: { permiso: 'pos', title: 'Punto de Venta', estado: 'construccion' }
      },
      {
        path: 'ventas',
        name: 'Ventas',
        component: Ventas,
        meta: { permiso: 'ventas', title: 'Ventas y Caja' }
      },
      {
        path: 'despachos',
        name: 'Despachos',
        component: Despachos,
        meta: { permiso: 'despachos', title: 'Despachos' }
      },

      /* ---------------- Cotizaciones ---------------- */
      {
        path: 'cotizaciones',
        name: 'Cotizaciones',
        component: Cotizaciones,
        meta: { permiso: 'cotizaciones', title: 'Cotizaciones' }
      },

      /* ---------------- Catálogo ---------------- */
      {
        path: 'inventario',
        component: Inventario,
        // El permiso base vive en el padre; lo repito en cada hija por si tu
        // guard de rutas revisa route.meta directo en vez de recorrer
        // route.matched. Si tu guard ya recorre matched, esto es redundante
        // pero inofensivo.
        meta: { permiso: 'inventario', title: 'Inventario' },
        children: [
          {
            path: '',
            name: 'Inventario',
            component: InventarioMenu,
            meta: { permiso: 'inventario', title: 'Inventario' }
          },
          {
            path: 'bodega',
            name: 'InventarioBodega',
            component: InventarioBodega,
            meta: { permiso: 'inventario', title: 'Inventario Bodega' }
          },
          {
            path: 'venta',
            name: 'InventarioVenta',
            component: InventarioVenta,
            meta: { permiso: 'inventario', title: 'Inventario Venta' }
          },
          {
            path: 'movimientos',
            name: 'InventarioMovimientos',
            component: InventarioMovimientos,
            meta: { permiso: 'inventario', title: 'Movimientos' }
          },
          {
            path: 'conteo',
            name: 'InventarioConteo',
            component: InventarioConteo,
            meta: { permiso: 'inventario', title: 'Conteo de stock' }
          }
        ]
      },
      {
        path: 'lotes',
        name: 'Lotes',
        component: Lotes,
        meta: { permiso: 'lotes', title: 'Lotes' }
      },
      {
        path: 'lotes/codigo/:codigo',
        name: 'LotePorCodigo',
        component: LoteDetalle,
        meta: { permiso: 'lotes', title: 'Lote', estado: 'construccion' }
      },
      {
        path: 'etiquetas',
        name: 'Etiquetas',
        component: Etiquetas,
        meta: { permiso: 'lotes', title: 'Etiquetas' }
      },
      {
        path: 'etiquetas/compra/:compraId',
        name: 'EtiquetasCompra',
        component: Etiquetas,
        meta: { permiso: 'lotes', title: 'Etiquetas de la compra' }
      },
      {
        /* La que se imprime al bajar de bodega al mesón: el vendedor la
           escanea para vender. Permiso de inventario, que es quien baja. */
        path: 'etiquetas/partida/:codigo',
        name: 'EtiquetasPartida',
        component: Etiquetas,
        meta: { permiso: 'inventario', title: 'Etiqueta de la partida' }
      },
      {
        path: 'compras',
        name: 'Compras',
        component: Compras,
        meta: { permiso: 'compras', title: 'Compras' }
      },
      {
        path: 'proveedores',
        name: 'Proveedores',
        component: Proveedores,
        meta: { permiso: 'compras', title: 'Proveedores' }
      },
      {
        path: 'mermas',
        name: 'Mermas',
        component: Mermas,
        meta: { permiso: 'mermas', title: 'Mermas' }
      },
      {
        path: 'clientes',
        name: 'Clientes',
        component: Clientes,
        meta: { permiso: 'clientes', title: 'Clientes y Fidelización' }
      },

      /* ---------------- Gestión ---------------- */
      {
        path: 'usuarios',
        name: 'Usuarios',
        component: Usuarios,
        meta: { permiso: 'usuarios', title: 'Equipo y Accesos' }
      },
      {
        path: 'configuracion',
        name: 'Configuracion',
        component: Configuracion,
        meta: { permiso: 'configuracion', title: 'Configuración' }
      },
      {
        path: 'promociones',
        name: 'Promociones',
        component: Promociones,
        meta: { permiso: 'promociones', title: 'Promociones' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { top: 0 }
  }
})

instalarGuards(router)

/* Pestaña abierta desde antes de un despliegue: las vistas se cargan en
   diferido y sus chunks viejos ya no están en el servidor. En vez de
   quedarse pegado en la vista anterior, se entra directo a la ruta pedida
   con la versión nueva. */
router.onError((error, to) => {
  if (!/Loading (CSS )?chunk|dynamically imported module/i.test(error?.message || '')) return
  /* Una sola vez por minuto: si el chunk falta también en la versión nueva
     (sin red, por ejemplo), recargar en bucle sería peor que el error. */
  const ultimo = Number(sessionStorage.getItem('recarga-chunk') || 0)
  if (Date.now() - ultimo < 60000) return
  sessionStorage.setItem('recarga-chunk', String(Date.now()))
  window.location.assign(to.fullPath)
})

if (process.env.NODE_ENV === 'development') {
  // Recorre rutas y children para armar la lista de paths absolutos
  const definidas = []
  const recolectar = (lista, base = '') => {
    lista.forEach(r => {
      // Une base + path evitando dobles barras
      const full = (base + '/' + (r.path || '')).replace(/\/+/g, '/').replace(/\/$/, '') || '/'
      if (r.path !== undefined) definidas.push(full)
      if (r.children) recolectar(r.children, full)
    })
  }
  recolectar(routes)

  MENU_COLIBRI.forEach(item => {
    if (!definidas.includes(item.path)) {
      console.warn(
        `[router] El menú apunta a "${item.path}" (${item.name}) pero no hay ruta con ese path.`
      )
    }
  })
}

export default router